import { pushTmsEvent } from "../../common/tracking-tms";
import { storeContextTracking } from "../utils/context-layer-variables";
export function pushLayerDisplayTmsEvent(isContextualized, funnel_name) {
  pushTmsEvent(window, 'step.display', {
    'feature_name': 'context_layer',
    'step_name': isContextualized ? 'information content' : 'store search',
    'funnel_name': funnel_name || storeContextTracking.funnelName
  });
}
export function sendCdlEventOnStepDisplay(step_name, funnel_name) {
  pushTmsEvent(window, 'step.display', {
    'feature_name': 'context_layer',
    'step_name': step_name,
    'funnel_name': funnel_name || storeContextTracking.funnelName
  });
}
export function pushStoreCardButtonTracking(buttonName) {
  pushTmsEvent(window, 'button.click', {
    'feature_name': 'context_layer',
    'step_name': 'information content',
    'funnel_name': storeContextTracking.funnelName,
    'button_name': buttonName
  });
}
export function pushStoreSearchEventsTracking(buttonName, buttonType, buttonLocation) {
  pushTmsEvent(window, 'button.click', {
    'button_name': buttonName,
    'button_type': buttonType,
    'button_location': buttonLocation
  });
}